export const getRevisionRowKey = (item, index) => {
  const identity = [
    item?.containerId ?? "",
    item?.captureTime ?? "",
    item?.id ?? "",
    item?.image_url ?? "",
    item?.sourceBlobName ?? "",
    item?.reviewTime || item?.deletedAt || item?.restoredAt || item?.date || "",
  ].join("|");

  return index == null ? identity : `${identity}|${index}`;
};
